import React from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/images/logo/glogix-logo-white.png";

// Shared shell for every public (non-auth) page: radar scan background,
// perspective grid floor, brand logo and an optional footer line.
export default function AuthLayout({ children, footer, wide = false }) {
    return (
        <div className="gx-auth">
            <div className="gx-auth-bg" aria-hidden="true">
                <div className="gx-radar">
                    <span className="gx-ring r1" />
                    <span className="gx-ring r2" />
                    <span className="gx-ring r3" />
                    <span className="gx-ring r4" />
                </div>
                <span className="gx-blip b1" />
                <span className="gx-blip b2" />
                <span className="gx-blip b3" />
                <div className="gx-grid-floor" />
            </div>

            <div className={`gx-auth-content${wide ? " is-wide" : ""}`}>
                <Link to="/login" className="gx-auth-brand">
                    <img src={logo} alt="GLOGIX" />
                </Link>

                {children}

                {footer && <div className="gx-auth-footer">{footer}</div>}
            </div>
        </div>
    );
}
